export const surveyCreate = 'survey/create'
export const surveyUpdate = 'survey/update'
export const surveyDelete = 'survey/delete'
export const surveyDefsLoad = 'survey/defs/load'
export const surveyDefsReset = 'survey/defs/reset'
export const surveyDefsIndexUpdate = 'survey/defs/indexUpdate'
export const surveyChainSave = 'survey/chain/save'
export const surveyChainItemDelete = 'survey/chain/delete'
export const surveyMetaUpdated = 'survey/metadata/updated'
export const surveyCategoryDelete = 'survey/category/delete'
export const surveyCategoryInsert = 'survey/category/insert'
export const surveyCategoryUpdate = 'survey/category/update'
export const surveyTaxonomyDelete = 'survey/taxonomy/delete'
export const surveyTaxonomyInsert = 'survey/taxonomy/insert'
export const surveyTaxonomyUpdate = 'survey/taxonomy/update'
